import { render, staticRenderFns } from "./RealtimeTps.vue?vue&type=template&id=7263e07f&scoped=true&"
import script from "./RealtimeTps.vue?vue&type=script&lang=js&"
export * from "./RealtimeTps.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeTps.vue?vue&type=style&index=0&id=7263e07f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7263e07f",
  null
  
)

export default component.exports